export enum StorageKeys {
    GEO_LOCATION_DATA = 'geo_location_data',
    RECENT_SEARCH = 'recentSearches',
    USER_LOCATION = 'userLocation',
    LAST_SEARCH = 'lastSearch',
    ACCESS_TOKEN = 'accessToken',
    REFRESH_TOKEN = 'refreshToken'
}
